export const ORIGINAL_CONTRACT_ADDRESS = "0x22af27d00c53C0Fba14446958864DB7e3fe0852c"; // PixelPepes V1
export const HELPER_CONTRACT_ADDRESS = "0x3C339F26F69b617E45d875888339B941987502C6"; // Helper Contract
export const INSCRIBED_CONTRACT_ADDRESS = "0x8137879e89eF12eb0E90F1A3d197835b5C06D232"; // New contract address
export const BASE64_BASE_URL = "https://ipfs.filebase.io/ipfs/QmQZppFFySj2rSworG2YZq6uoUPTABTajqQ9dqFV8oog55/";
export const METADATA_BASE_URL = "https://ipfs.filebase.io/ipfs/QmdUApdcT7rwXdpULJJi9Xp1s2X3TbmLY1BrpWdqzb8s8Q/";
export const BASEDAI_CHAIN_ID = 32323;
